import { render } from "./FloatingAdminToolbar.vue?vue&type=template&id=5faadd18&scoped=true"
import script from "./FloatingAdminToolbar.vue?vue&type=script&lang=js"
export * from "./FloatingAdminToolbar.vue?vue&type=script&lang=js"

import "./FloatingAdminToolbar.vue?vue&type=style&index=0&id=5faadd18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faadd18"]])

export default __exports__